<template>
  <div class="authorityManagement mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="indexPage">
      <DepartmentTree @getTreeActive="getTreeActive"
        @getActiveItem="getActiveItem"
        ref="componentTree" />
      <UserRights @getActiveItem="getActiveItem"
        :treeActive="treeActive"
        :treeAllData="treeAllData"
        ref="componentUser"
        v-show="!showMinaPage" />
      <UserDetails v-if="showMinaPage" />
      <PowerDialog v-if="powerDialogVisible && roleAuthority"
        :activeItem="activeItem" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import DepartmentTree from "@/components/houqinguanli/quanxianguanli/DepartmentTree";
import UserRights from "@/components/houqinguanli/quanxianguanli/UserRights";
import PowerDialog from "@/components/houqinguanli/quanxianguanli/PowerDialog";
import UserDetails from "@/components/houqinguanli/quanxianguanli/UserDetails";
import { judgeAuthority } from "@/assets/js/utils";
export default {
  components: {
    DepartmentTree,
    UserRights,
    PowerDialog,
    UserDetails,
  },
  data() {
    return {
      powerDialogVisible: false,
      activeItem: {},
      treeActive: {},
      treeAllData: [],
      roleAuthority: false,
      showMinaPage: false,
    };
  },
  methods: {
    getActiveItem(item) {
      this.activeItem = item;
    },
    getTreeActive(item) {
      this.treeActive = item;
      this.$nextTick(() => {
        this.updateUser();
      });
    },
    updateUser() {
      this.$refs.componentUser.handleSizeChange(10);
    },
    updateTree() {
      this.$refs.componentTree.getTreeLists();
    },
  },
  created() {
    this.roleAuthority = judgeAuthority("houqinguanli:authManager:edit");
  },
  beforeDestroy() {
    this.$store.commit("SET_ACTIVEUSER", {});
  },
};
</script>

<style lang="scss" scoped>
.authorityManagement {
  .indexPage {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
  }
}
</style>